<template>
  <div>
    <div
      class="w-full text-xs leading-3 tracking-wide uppercase label"
      :class="[{ 'text-grey': disabled, 'required': required && !disabled }, labelClassString]"
      v-text="label"
    />
    <div class="">
      <slot />
    </div>
  </div>
</template>

<script lang="ts" setup>
interface IProps {
  label: string
  labelClassString: string
  translate?: boolean
  required?: boolean
  disabled?: boolean
}

withDefaults(defineProps<IProps>(), { translate: false, required: false, disabled: false, labelClassString: '' })
</script>

<style lang="scss" scoped>
.label {
  &.required:before {
    content: "* ";
    color: red;
    font-size: 10px;
    vertical-align: sub;
  }
}
</style>
